/* eslint-disable no-plusplus */
/* eslint-disable jsx-a11y/control-has-associated-label */
/* eslint-disable react/prop-types */
/* eslint-disable max-len */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getDistanceMax, getDistanceMinPositive } from "../../store/data/cartesianData";
import {
  selectMechanics,
  setMechanics,
  setSelectedMechanicsField,
  setSelectedMechanicsFieldIndex
} from "../../store/slices/cartesian";
import { LOAD_PARAMETERS_FIELD } from "../../../Common/utils/api/common";
import t from "../../../Common/utils/translation/translator";
import MsxIcons from "../../../Common/components/Icons/MsxIcons/MsxIcons";
import LoadsParametersRows from "../LoadsParametersRows/LoadsParametersRows";
import "./LoadsParameters.scss";

const PAYLOAD_LIMIT = 2000;
const PAYLOAD = "Payload";
const DX = "dx";
const DY = "dy";
const DZ = "dz";
const DISTANCE_MAX = getDistanceMax();
const DISTANCE_MIN_POSITIVE = getDistanceMinPositive();

const LoadParameterHeader = ({ name, inputClass, ...props }) => (
  <div
    className={`LoadParameterHeader ${inputClass} bd-white bg-white border-b-[1px] border-b-[#008a16] border-solid text-sm text-gray-500`}
    role="columnheader"
    {...props}
  >
    {name}
  </div>
);

const CenterOfLoadSection = ({ errorPayLoad, ...props }) => (
  <div className="CenterOfLoadSection lp-flex-table header" role="rowgroup" {...props}>
    <div className="lp-flex-row-small lp-topography lp-table-border-left lp-table-border-right " role="columnheader" />
    <div className="lp-flex-row-combined text-red-600 flex items-start gap-1 !-mt-0.5">
      {errorPayLoad && (
        <>
          <MsxIcons name="alert" size="nano" />
          <div className="text-sm flex justify-start">{t("msizer.ui.mandatory_field_missing")}</div>
        </>
      )}
    </div>
    <div className="lp-flex-row-center-load bd-white text-sm text-gray-600 bg-white border-solid" role="columnheader">
      {t("cartesian.ui.mechanics.load_parameters_center_of_load")}
    </div>
    <div className="lp-flex-row-small lp-topography " role="columnheader" />
  </div>
);

const CenterOfTableHeaderSection = ({ ...props }) => (
  <div className="CenterOfTableHeaderSection lp-flex-table header" role="rowgroup" {...props}>
    <div className="lp-flex-row-small-header bd-white lp-topography bg-white" role="columnheader">
      <div className="lp-header-start-sep-first border-left" />
      <div className="lp-header-start-sep-second border-b-[1px] border-b-[#008a16]" />
    </div>
    <LoadParameterHeader
      data-testid="load-parameter-header-title"
      name={t("cartesian.ui.mechanics.load_parameters_title")}
      inputClass="lp-flex-row-large-header"
    />
    <LoadParameterHeader
      data-testid="load-parameter-header-payload"
      name={t("cartesian.ui.mechanics.load_parameters_payload")}
      inputClass="lp-flex-row-header-left-align"
    />
    <LoadParameterHeader data-testid={`load-parameter-header-${DX}`} name={DX} inputClass="lp-flex-row-header" />
    <LoadParameterHeader data-testid={`load-parameter-header-${DY}`} name={DY} inputClass="lp-flex-row-header" />
    <LoadParameterHeader data-testid={`load-parameter-header-${DZ}`} name={DZ} inputClass="lp-flex-row-header" />
    <div className="lp-flex-row-small-header bd-white lp-topography bg-grey" role="columnheader">
      <div className="lp-header-start-sep-first" />
      <div className="lp-header-start-sep-first" />
    </div>
  </div>
);

const LoadParameterTableSection = ({ errorPayLoad, ...props }) => (
  <div className="LoadParameterTableSection lp-table-container" role="table" {...props}>
    <CenterOfLoadSection data-testid="center-of-load-section" errorPayLoad={errorPayLoad} />
    <CenterOfTableHeaderSection data-testid="center-of-table-header-section" />
  </div>
);

const AddSection = ({ onClick, isDisabled, ...props }) => (
  <div className="AddSection lp-add-section" {...props}>
    <AddButtonSection data-testid="add-button-section" onClick={onClick} isDisabled={isDisabled} />
    <AddLoadSection data-testid="add-load-section" onClick={onClick} isDisabled={isDisabled} />
  </div>
);

const AddLoadSection = ({ onClick, isDisabled, ...props }) => (
  <button disabled={isDisabled} type="button" onClick={onClick} className="AddLoadSection lp-add-load" {...props}>
    {t("cartesian.ui.mechanics.load_parameters_add_load")}
  </button>
);

const AddButtonSection = ({ onClick, isDisabled, ...props }) => (
  <div className="AddButtonSection lp-add-load-button-top" {...props}>
    <button disabled={isDisabled} type="button" onClick={onClick} className="lp-add-load-button">
      action_add_flat
    </button>
  </div>
);

const LoadsParametersHeaderSection = ({ ...props }) => (
  <div
    className="LoadsParametersHeaderSection h-[34px] bg-primary flex items-center w-full lp-table-border-bottom"
    {...props}
  >
    <div className="lp-header">{t("cartesian.ui.mechanics.load_parameters")}</div>
    <span className="light-error-active">*</span>
  </div>
);

const LoadsParameters = ({ ...props }) => {
  const dispatch = useDispatch();
  const mechanics = useSelector(selectMechanics);
  const [indexSelected, setIndexSelected] = useState(-1);

  const dispatchMechanics = (newRowData, index, field) => {
    const newData = {
      ...mechanics,
      loadsParameters: newRowData,
      selectedIndex: index,
      selectedField: field
    };
    dispatch(setMechanics(newData));
  };

  let errorPayLoad = false;
  const lps = [...mechanics.loadsParameters];
  for (let index = 0; index < lps.length; index++) {
    errorPayLoad =
      errorPayLoad ||
      lps[index].payload === "" ||
      lps[index].payload <= 0 ||
      lps[index].title === "" ||
      lps[index].dx === "" ||
      lps[index].dx < 0 ||
      lps[index].dy === "" ||
      lps[index].dy < 0 ||
      lps[index].dz === "" ||
      lps[index].dz < 0 ||
      !Number.isInteger(Number(lps[index].payload));
  }

  const getNewIndex = (loadparams) => {
    let max = 0;
    for (let index = 0; index < loadparams.length; index++) {
      const { title } = loadparams[index];
      const loadName = t("cartesian.ui.mechanics.load_parameters.load");
      const loadindex = title.match(loadName + " [0-9]+") ? Number(title.replace(loadName + " ", "").trim()) : 0;
      max = Math.max(max, loadindex);
    }
    return max + 1;
  };

  const addRowTable = () => {
    const newIndex = getNewIndex(mechanics.loadsParameters);
    const loadName = t("cartesian.ui.mechanics.load_parameters.load");
    const data = {
      id: new Date().getTime(),
      enable: !(mechanics.loadsParameters.length > 0),
      title: `${loadName} ${newIndex}`,
      payload: "1",
      dx: "0",
      dy: "0",
      dz: "100"
    };
    const newRowData = [...mechanics.loadsParameters, data];
    dispatchMechanics(newRowData, newRowData.length - 1, LOAD_PARAMETERS_FIELD);
  };

  const tableRowRemove = (index) => {
    if (mechanics.loadsParameters.length === 1) {
      return;
    }
    const dataRow = [...mechanics.loadsParameters];
    dataRow.splice(index, 1);
    dispatchMechanics(dataRow, dataRow.length - 1, LOAD_PARAMETERS_FIELD);
  };

  const handleInputFocusIn = (i) => {
    setIndexSelected(i);
    // const data = [...mechanics.loadsParameters];
    // let isEnableChanged = false;
    // for (let index = 0; index < data.length; index++) {
    //   // eslint-disable-next-line no-useless-computed-key
    //   if (i === index && !data[index].enable) {
    //     isEnableChanged = true;
    //   }
    //   data[index] = { ...data[index], enable: i === index };
    // }
    // if (isEnableChanged) {
    //   dispatchMechanics(data, i, LOAD_PARAMETERS_FIELD);
    // } else {
    dispatch(setSelectedMechanicsField(LOAD_PARAMETERS_FIELD));
    dispatch(setSelectedMechanicsFieldIndex(i));
    //}
  };

  const handleInputFocusOut = () => {
    /*
    setIndexSelected(-1);
    const data = [...mechanics.loadsParameters];
    dispatchMechanics(data, -1, "");
    */
  };

  const onValUpdateLP = (i, event) => {
    const { name, checked } = event.target;
    let { value } = event.target;
    const data = [...mechanics.loadsParameters];

    if ((name === DX || name === DY || name === DZ || name === PAYLOAD.toLowerCase()) && isNaN(value)) {
      return;
    }

    if ((name === DX || name === DY || name === DZ) && (value < DISTANCE_MIN_POSITIVE || value > DISTANCE_MAX)) {
      return;
    }

    if (name === PAYLOAD.toLowerCase() && (value < 0 || value > PAYLOAD_LIMIT)) {
      return;
    }

    if (
      (name === DX || name === DY || name === DZ || name === PAYLOAD.toLowerCase()) &&
      !isNaN(value) &&
      value !== ""
    ) {
      value = parseInt(value);
      event.target.value = value;
    }

    data[i] = { ...data[i], [name]: name === "enable" ? checked : value };
    for (let index = 0; index < data.length; index++) {
      // eslint-disable-next-line no-useless-computed-key
      data[index] = { ...data[index], ["enable"]: i === index };
    }

    setIndexSelected(i);
    dispatchMechanics(data, i, LOAD_PARAMETERS_FIELD);
  };

  return (
    <div className="LoadsParameters mt-6 mb-6" {...props}>
      <LoadsParametersHeaderSection data-testid="loads-parameters-headers-section" />
      <div className="pb-2 bg-[#E7E6E6] lp-table-border-left lp-table-border-right" />
      <LoadParameterTableSection data-testid="load-parameter-table-section" errorPayLoad={errorPayLoad} />
      <div className="pb-[1px] bg-[#E7E6E6] lp-table-border-left lp-table-border-right" />
      <LoadsParametersRows
        data-testid="loads-parameters-rows"
        rows={mechanics.loadsParameters}
        tableRowRemove={tableRowRemove}
        onValUpdate={onValUpdateLP}
        handleInputFocusIn={handleInputFocusIn}
        handleInputFocusOut={handleInputFocusOut}
        indexSelected={mechanics.selectedField === LOAD_PARAMETERS_FIELD ? indexSelected : -1}
        showToolTip={mechanics.loadsParameters.length === 1}
      />
      <AddSection
        data-testid="add-section"
        onClick={addRowTable}
        isDisabled={mechanics.loadsParameters.length >= 5 || errorPayLoad}
      />
    </div>
  );
};

export default LoadsParameters;
